import EnvFile from "./assets/env-production.json";

declare global {
  interface Window {
    MLBBest: {
      envVariables: any;
    };
  }
}

window.MLBBest = {
  envVariables: EnvFile,
};
